export default __webpack_public_path__ + "static/media/anim-background.2fab26d6.png";